<template>
  <div class="tw-w-full">
    <ui-textfield
      input-type="textarea"
      class="textarea"
      fullwidth
      :id="textfieldId"
      :maxlength="maxlength"
      :placeholder="placeholder"
      v-model="text"
      @input="resize"
      :disabled="isDisabled"
    >
    </ui-textfield>
    <div
      v-if="withCounter"
      class="textarea__count"
      :class="{ 'textarea__count-disabled': isDisabled }"
    >
      {{ text.length }} /
      {{ addThousandSeparator(maxlength.toString(), ',') }} Characters
    </div>
  </div>
</template>

<script setup>
import { addThousandSeparator } from '@/acv/utilities/money';

const props = defineProps({
  placeholder: { type: String, default: '' },
  maxlength: {
    type: Number,
  },
  value: {
    type: String,
    default: '',
  },
  withCounter: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['onTextEntered']);

const textfieldId = computed(() => {
  return useUniqueId(`textarea-input-`);
});

const text = ref(props.value);

const resize = () => {
  emit('onTextEntered', text.value);
  const element = document.querySelector(`#${textfieldId._value} textarea`);
  if (element) {
    element.style.height = '18px';
    element.style.height = `${element.scrollHeight}px`;
  }
};
</script>

<style lang="scss" scoped>
:deep(.mdc-text-field__resizer) {
  resize: none;
}

.textarea__count {
  @apply tw-text-xs
    tw-text-text-secondary
    tw-mt-1
    tw-pl-4;

  &.textarea__count-disabled {
    @apply tw-text-text-disable;
  }
}
</style>
